<template>
  <div class="projects-page">
    <v-layout>
      <v-flex>
        <!-- <div class="project-filter">
          <v-tabs v-model="tab">
            <v-layout justify-space-around>
              <v-tab>Filtrer sur la période</v-tab>
              <v-tab disabled>Filtrer sur une source</v-tab>
            </v-layout>
            <v-tabs-items v-model="tab">
              <v-tab-item>
                <v-layout justify-space-between>
                  <v-radio-group
                    hide-details
                    v-model="search.date_type"
                    class="mr-8 mb-0 mt-3"
                  >
                    <v-radio
                      value="CREATE"
                      hide-details
                      class="mt-5"
                      label="Date de CREATION"
                    ></v-radio>

                    <v-radio
                      value="TRANSF"
                      hide-details
                      class="mb-3"
                      label="Date de TRANSFERT"
                    ></v-radio>

                    <v-checkbox
                      v-model="processedProjects"
                      hide-details
                      class="mb-3"
                      label="Fiche non traitée"
                    ></v-checkbox>
                  </v-radio-group>

                  <v-flex>
                    <v-layout wrap justify-center>
                      <v-flex sm6 mt-3 mb-5 mr-3>
                        <v-dialog
                          v-model="search.dialog_date_from"
                          width="290px"
                        >
                          <template v-slot:activator="{ on }">
                            <v-text-field
                              :value="search.date_from | dateFormat"
                              label="Du"
                              append-icon="mdi-calendar"
                              v-on="on"
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            first-day-of-week="1"
                            v-model="search.date_from"
                            @change="search.dialog_date_from = false"
                          ></v-date-picker>
                        </v-dialog>
                      </v-flex>
                      <v-flex sm6 mt-3 mb-5>
                        <v-dialog v-model="search.dialog_date_to" width="290px">
                          <template v-slot:activator="{ on }">
                            <v-text-field
                              :value="search.date_to | dateFormat"
                              label="Au"
                              append-icon="mdi-calendar"
                              v-on="on"
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            first-day-of-week="1"
                            v-model="search.date_to"
                            @change="search.dialog_date_to = false"
                          ></v-date-picker>
                        </v-dialog>
                      </v-flex>

                      <v-flex>
                        <v-layout class="mb-5">
                          <v-select
                            class="mr-4"
                            item-text="label"
                            item-value="id"
                            hide-details
                            label="Agence :"
                            filled
                            disabled
                            clearable
                          ></v-select>
                        </v-layout>
                      </v-flex>

                      <v-flex sm6>
                        <v-layout class="mb-5">
                          <v-select
                            item-text="label"
                            item-value="id"
                            hide-details
                            v-model="search.applicator"
                            :items="applicatorsList"
                            label="Applicateur :"
                            filled
                            clearable
                          ></v-select>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
                <v-layout justify-space-between></v-layout>
                <v-layout justify-end> </v-layout>
              </v-tab-item>

              <v-tab-item>
                <v-layout justify-space-between wrap>
                  <v-flex sm6 mt-3 mb-5>
                    <v-text-field
                      hide-details
                      outlined
                      label="Nom"
                    ></v-text-field>
                  </v-flex>
                  <v-flex sm6 mt-3 mb-5>
                    <v-text-field
                      hide-details
                      outlined
                      label="N° Appareil"
                    ></v-text-field>
                  </v-flex>
                  <v-flex sm6 mb-5>
                    <v-text-field
                      hide-details
                      outlined
                      label="Prénom"
                    ></v-text-field>
                  </v-flex>
                  <v-flex sm6 mb-5>
                    <v-text-field
                      hide-details
                      outlined
                      label="Numéro de fiche"
                    ></v-text-field>
                  </v-flex>
                  <v-flex sm6 mb-5>
                    <v-text-field
                      hide-details
                      outlined
                      label="N° Dossier"
                    ></v-text-field>
                  </v-flex>
                  <v-flex sm1>
                    <v-btn block>
                      <v-icon>mdi-magnify</v-icon>
                    </v-btn>
                  </v-flex>
                </v-layout>
              </v-tab-item>
            </v-tabs-items>
          </v-tabs>
        </div> -->

        <ProjectFilter />

        <ProjectTable @click:row="showPreviewPanel" />
      </v-flex>

      <ProjectPreview
        transition="slide-x-transition"
        v-if="showPreview && project"
        :project="project"
        :loading="previewIsLoading"
      />
    </v-layout>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "ProjectsPage",
  components: {
    ProjectTable: () => import("./components/ProjectTable"),
    ProjectFilter: () => import("./components/ProjectFilter"),
    ProjectPreview: () => import("./components/ProjectPreview")
  },
  data() {
    return {
      tab: null,
      loading: false,

      // Preview panel
      previewIsLoading: false,
      showPreview: false,
      project: null,

      processedProjects: false
    };
  },

  methods: {
    // Fetch projects
    ...mapActions({
      fetchProjectLight: "projects/fetchProjectLight"
    }),

    // Gets project info and show preview panel
    async showPreviewPanel(project) {
      try {
        this.showPreview = true;
        this.previewIsLoading = true;
        this.project = await this.fetchProjectLight(project.uuid);
        this.previewIsLoading = false;
      } catch (error) {
        console.error(error);
      }
    }
  }
};
</script>

<style lang="scss">
.slide-item {
  transition: all 1s;
  display: inline-block;
  margin-right: 10px;
}
.slide-enter, .slide-leave-to
/* .slide-leave-active below version 2.1.8 */ {
  opacity: 0;
  transform: translateY(30px);
}
.slide-leave-active {
  position: absolute;
}

.projects-page {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  .project-preview {
    width: 300px;
    margin-left: 40px;
    height: 100%;
    order: 3;
    background-color: #f7f7f7;
    padding: 15px;
    + .projects-list {
      width: calc(100vw - 300px - 40px);
    }
    ~ .project-filter {
      width: calc(100vw - 300px - 40px);
    }
    .v-btn {
      background-color: #006064 !important;
      color: white !important;
    }
    .sticky-cont {
      position: sticky;
      top: 0;
    }
  }
  .projects-list {
    flex: 1;
    order: 2;
  }
  .project-filter {
    order: 1;
    max-height: 300px;
    margin-bottom: 30px;
    position: relative;
    .v-btn {
      background-color: #006064 !important;
      color: white !important;
    }
  }
}
</style>
